// frontend/src/services/authService.js

// 1. Importações
import api from './api';

/**
 * Função para registrar um novo usuário.
 * @param {string} email - O email do usuário.
 * @param {string} password - A senha do usuário.
 * @returns {Promise<object>} A resposta da API.
 */
const register = (email, password) => {
    // Envia uma requisição POST para o endpoint de registro.
    return api.post('/api/auth/register', { email, password });
};

/**
 * Função para logar um usuário.
 * @param {string} email - O email do usuário.
 * @param {string} password - A senha do usuário.
 * @returns {Promise<object>} A resposta da API contendo o token e os dados do usuário.
 */
const login = async (email, password) => {
    const response = await api.post('/api/auth/login', { email, password });
    if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
};


/**
 * Função para fazer logout do usuário.
 */
const logout = () => {
    // Simplesmente remove os dados do usuário do localStorage.
    localStorage.removeItem('user');
};

// Cria um objeto para exportar todas as funções de uma vez.
const authService = {
    register,
    login,
    logout,
};

export default authService;